import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/auth/Login";
import Layout from "./layout/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import TabsPerfil from "./pages/listado/TabsPerfil";
import Calendario from "./pages/cdr/Calendario";
import Financiero from "./pages/financiero/Financiero";
import Monitor from "./pages/cdr/Monitor";
import ResumenEmpresaPage from "./pages/resumenes/ResumenEmpresaPage";
import { CdrPipelineProcessor } from "./pages/Procesador/CdrPipelineProcessor";
import Manual from "./pages/manual/Manual";
import SessionProvider, { useSession } from "@/context/SessionProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GestionUsuarios from "./pages/listado/GestionUsuarios";
import GestionPerfiles from "./pages/listado/GestionPerfiles";
import ConfiguracionCuentas from "./pages/clearcom/ConfiguracionCuentas";
import Bloqueos from "./pages/clearcom/Bloqueos";
import CpsAnalisis from "./pages/analisis/CpsAnalisis";
import CpsDetalleCuenta from "./pages/analisis/CpsDetalleCuenta";
import CpsDetalleDia from "./pages/analisis/CpsDetalleDia";
import TraficoResult from "./pages/analisis/TraficoResult";

// Ruta protegida: espera a que cargue la sesión y bloquea si no hay user
function ProtectedRoute({ children }) {
  const { user, loading } = useSession();
  if (loading) return null; // o un spinner/skeleton
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <SessionProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Rutas protegidas */}
          <Route
            path=""
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="listado" element={<TabsPerfil />} />
            <Route path="cdr/calendario" element={<Calendario />} />
            <Route path="cdr/monitor" element={<Monitor />} />
            <Route path="admon/financiero" element={<Financiero />} />
            <Route path="admon/procesador-avanzado" element={<CdrPipelineProcessor />} />
            <Route path="admin/finanzas/empresa/:empresaId/resumen" element={<ResumenEmpresaPage />} />
            <Route path="resumenes" element={<ResumenEmpresaPage />} />
            <Route path="manual" element={<Manual />} />
            <Route path="/admin/usuarios" element={<GestionUsuarios />} />
            <Route path="/admin/perfiles" element={<GestionPerfiles />} />
            <Route path="clearcom/configuracion" element={<ConfiguracionCuentas />} />
            <Route path="clearcom/bloqueos" element={<Bloqueos />} />
            <Route path="analisis/cps" element={<CpsAnalisis />} />
            <Route
              path="analisis/cps/:iAccount"
              element={<CpsDetalleCuenta />}
            />
            <Route
              path="analisis/cps/:iAccount/:fecha"
              element={<CpsDetalleDia />}
            />
            <Route path="analisis/trafico" element={<TraficoResult />} />
          </Route>
        </Routes>

        <ToastContainer />
      </Router>
    </SessionProvider>
  );
}